import { useSelector } from '../store/reducers';
import { DynamicRollupsState } from '../reducers/dynamicRollups';

const useDynamicRollups = (): DynamicRollupsState => {
    const { data, error, loadingStatus } = useSelector(({ dynamicRollups }) => dynamicRollups);
    return { data, error, loadingStatus };
};

export default useDynamicRollups;
